export const APP_NAME = "Logística Woodward";
export const PERSIST_STORE_NAME = "portal";
export const REDIRECT_URL_KEY = "redirectUrl";
